import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatTabsModule } from '@angular/material/tabs'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentPortalMenuModule } from '../appointment-portal-menu'
import { EligibilityCardModule } from '../eligibility-card'
import { AppointmentEligibilityCardComponent } from './appointment-eligibility-card.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    AppointmentPortalMenuModule,
    EligibilityCardModule,
    DirectivesModule,
    TranslateModule,
  ],
  exports: [
    AppointmentEligibilityCardComponent,
  ],
  declarations: [
    AppointmentEligibilityCardComponent,
  ],
  providers: [],
})
export class AppointmentEligibilityCardModule { }
